/* ExecutionTypeRenderer.js */

"use strict";

class ExecutionTypeRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("execution-type-column");
        this._rootElem.component = this._model;

        this._scheduledIcon = document.createElement("base-icon-gl");
        this._scheduledIcon.dataset.icon = "worktrigger.scheduled";
        this._scheduledIcon.setAttribute("title", "Scheduled");

        this._manualIcon = document.createElement("base-icon-gl");
        this._manualIcon.dataset.icon = "worktrigger.manual";
        this._manualIcon.setAttribute("title", "Manual");

        this._unknownIcon = document.createElement("base-icon-gl");
        this._unknownIcon.dataset.icon = "common.unknown";
        this._unknownIcon.setAttribute("title", "Unknown");

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._scheduledIcon.remove();
            this._scheduledIcon = undefined;

            this._manualIcon.remove();
            this._manualIcon = undefined;

            this._unknownIcon.remove();
            this._unknownIcon = undefined;

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("ExecutionType", (this._onExecutionType = this._onExecutionType.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("ExecutionType");
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setExecutionType(this._model.getExecutionType());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onExecutionType(newVal) {
        this._setExecutionType(newVal);
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setExecutionType(newVal) {
        this._rootElem.innerHTML = "";
        if (newVal) {
            if (newVal === "SCHEDULE" || newVal === "SYSTEM" || newVal === "GluwareScheduler") {
                this._rootElem.appendChild(this._scheduledIcon);
            } else {
                this._rootElem.appendChild(this._manualIcon);
            }
        } else {
            this._rootElem.appendChild(this._unknownIcon);
        }
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = ExecutionTypeRenderer;
